import { supabase } from './api'

export async function getAllData() {
  const { data, error } = await supabase
    .from("goalstracker")
    .select()
    // .order("id", { ascending: true });
  if (error) {
    throw new Error("Failed to fetch data",error);
  }

  return data;
}

export async function getStudentIdData(id) {
  const { data, error } = await supabase.from('goalstracker').select()
  .eq('studentId', id);
  if (error) {
    throw new Error('Failed to fetch data')
  }

  return data;
}

export async function addData(adata) {
  const { data, error } = await supabase.from('goalstracker').insert(adata).select();

  if (error) {
    throw new Error('Failed to fetch data')
  }

  return data;
}

export async function updateData(udata) {
  //console.log("udata",udata);
  const { data, error } = await supabase.from('goalstracker').update(udata).eq('id', udata.id).select();
  console.log("error",error,data);
  if (error) {

    throw new Error('Failed to fetch data')

  }

  return data;
}

export async function deleteIdData(id) {
  const { data, error } = await supabase.from('goalstracker').delete()
  .eq('id', id);
  if (error) {
    throw new Error('Failed to fetch data')
  }

  return data;
}
